<script>
import { Helper } from '@/mixin/helper'
import { getClient } from '@/services/identity'
import RestEditableTable from '@/components/RestEditableTable'
import * as customIntervalApi from '../lib/customInterval'
import { mapGetters } from 'vuex'

const identityClient = getClient()

export default {
  components: {
    RestEditableTable,
  },
  mixins: [Helper],
  data() {
    return {
      isTableDataAvailable: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      return 'Jenis Kendaraan'
    },

    fields() {
      return [
        {
          key: 'id',
          editable: false,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
        {
          key: 'subscription',
          thClass: 'mc-table--250',
          editable: true,
          label: 'Subscription Type',
          placeholder: 'Subscription Type',
          validation: 'required',
          type: 'select-resourceful',
          trackBy: 'subscription',
          optionsGetter: this.queries.subscriptionType,
          getInitialObject: (item) => {
            return { subscription: item.subscription }
          },
          optionLabelFn: ({ item }) => item.subscription,
          'validation-messages': {
            required: this.$t('global.validation.required'),
            max: 'Nama subscription tidak lebih dari 64 karakter',
          },
          customLabelFn: (item, key = 'subscription') =>
            item[`${key}`] || item[`${key}`] !== '' ? item[`${key}`] : '-',
        },
        {
          key: 'device_name',
          thClass: 'mc-table--250',
          editable: true,
          label: 'Device',
          placeholder: 'Device',
          validation: 'required',
          type: 'select-resourceful',
          trackBy: 'device_name',
          optionsGetter: this.queries.deviceTypes,
          getInitialObject: (item) => {
            return { device_name: item.device_name }
          },
          optionLabelFn: ({ item }) => item.device_name,
          'validation-messages': {
            required: this.$t('global.validation.required'),
            max: 'Nama device tidak lebih dari 64 karakter',
          },
          customLabelFn: (item, key = 'device_name') =>
            item[`${key}`] || item[`${key}`] !== '' ? item[`${key}`] : '-',
        },
        {
          key: 'interval_name',
          thClass: 'mc-table--50',
          editable: true,
          label: this.$t('qcdevice.customInterval.column.customInterval'),
          placeholder: this.$t('qcdevice.customInterval.column.customInterval'),
          validation: 'required',
          type: 'select-resourceful',
          trackBy: 'interval_name',
          optionsGetter: this.queries.customIntervalOpt,
          getInitialObject: (item) => {
            return { interval_name: item.interval_name }
          },
          optionLabelFn: ({ item }) => item.interval_name,
          'validation-messages': {
            required: this.$t('global.validation.required'),
            max: 'Nama device tidak lebih dari 64 karakter',
          },
          customLabelFn: (item, key = 'interval_name') =>
            item[`${key}`] || item[`${key}`] !== '' ? item[`${key}`] : '-',
        },
        {
          key: 'icon',
          editable: true,
          thClass: 'd-none',
          tdClass: 'd-none',
        },
      ]
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    apiClient() {
      return {
        get: customIntervalApi.get,
        show: customIntervalApi.show,
        store: customIntervalApi.store,
        delete: customIntervalApi.deleteMany,
        update: customIntervalApi.update,
      }
    },
    queries() {
      return {
        deviceTypes: async (opts) => {
          if (opts) {
            const { limit = 10, page = 1, search = '' } = opts;
            const deviceTypes = customIntervalApi.constants.data.deviceTypes;

            const filteredDeviceTypes = deviceTypes.filter((device) =>
              device.device_name.toLowerCase().includes(search.toLowerCase())
            );

            const startIndex = (page - 1) * limit;
            const paginatedResult = filteredDeviceTypes.slice(startIndex, startIndex + limit);

            const res = {
              metadata: {
                total_page: Math.ceil(filteredDeviceTypes.length / limit),
                total_count: filteredDeviceTypes.length,
                count: paginatedResult.length,
                page: page,
              },
              data: {
                paginated_result: paginatedResult,
              },
            };

            return res;
          }
        },
        subscriptionType: async (opts) => {
          if (opts) {
            const subscription = await identityClient.get(
              `api/subscription?page=${opts?.page.toString()}&limit=${
                opts?.limit.toString()
              }&_subscription(subscription,like)=${opts?.search || ''}`
            )
            
            const paginatedResult = subscription?.data.data.pagination_result ?? []

            const res = {
              metadata: {
                total_page: subscription?.data.metadata.total_page,
                total_count: subscription?.data.metadata.total_count,
                count: paginatedResult.length,
                page: subscription?.data.metadata.page,
              },
              data: {
                paginated_result: paginatedResult,
              },
            }

            return res
          }
        },
        customIntervalOpt: (opts) => {
          const { limit = 10, page = 1, search = '' } = opts || {};
          const intervals = customIntervalApi.constants.data.intervals;

          const filteredIntervals = intervals.filter((interval) =>
            interval.interval_name.toLowerCase().includes(search.toLowerCase())
          );

          const startIndex = (page - 1) * limit;
          const paginatedResult = filteredIntervals.slice(startIndex, startIndex + limit);

          const res = {
            data: paginatedResult,
            has_more: page * limit < filteredIntervals.length,
            page: page,
            size: paginatedResult.length,
            total_count: filteredIntervals.length,
            total_page: Math.ceil(filteredIntervals.length / limit),
          };

          return res;
        }
      }
    },
    exception() {
      const exceptionFields = ['manufacturer']
      return exceptionFields
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    isContains(search, name) {
      const searchContains = RegExp(search ?? '', 'gi').exec(name ?? '')
      return searchContains != null && searchContains.length > 0
    },
    async handleChange() {
      const customIntervalRef = this.$refs.customIntervalRef.$refs
      await this.$nextTick()
      this.fields.forEach((field) => {
        if (!field.editable) return
        customIntervalRef[`${field.key}-ref`].$el.addEventListener(
          'keydown',
          Helper.methods.preventTabKey
        )
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      <div class="card-body">
        <RestEditableTable
          ref="customIntervalRef"
          :fields="fields"
          :apiClient="apiClient"
          :bulkDeleteApi="true"
          :hidePagination="true"
          :showNoData="!isTableDataAvailable"
          :enableDeleteButton="hasAccessAll(['custom-interval:delete'])"
          :enableAddButton="hasAccessAll(['custom-interval:create'])"
          :isEnableEditButton="hasAccessAll(['custom-interval:update'])"
          @available-change="handleDataAvailable"
          trackBy="custom_interval_id"
          @changeData="handleChange"
        />
      </div>
    </div>
  </div>
</template>
